// ESlint complains about prop-types, you need to define it
import PropTypes from 'prop-types';
Blurb.propTypes = {
  handleModal: PropTypes.func.isRequired,
};

// this are the details for this attestation field
export function Config() {
  return {
    name: 'txAdultDriverASC', // this used as the field name as well as the unique identifier
    productIds: [
      // 'bcabc100-3f77-4b90-8115-e234f72bb980', // Texas Adult Driver Education
    ],
    errorMsg: `You must attest that you read and understand the <strong>Texas Adult Driver Education</strong> course enrollment contract by checking the box.`,
    onlyForBulk: false, // set to true if this attestation is only for bulk purchase
    type: 'checkbox', // iAgree, signature, checkbox
  };
}

// this is the blurb we display to tell the user what this attestation field is for
export function Blurb() {
  return (
    <>
      By checking this box, the Student accepts the{' '}
      <a
        href="https://cdn.certus.com/global/pdf/tx-ad-enrollment-contract-asc.pdf"
        target="_blank"
        rel="noopener nofollow noreferrer"
      >
        Texas Adult Driver Education enrollment contract
      </a>
      .
    </>
  );
}

// this is the explaination of the attestation, the full details of what the user is aggreeing to
export function ModalContent() {
  return null;
}
